import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { BrandsDashboardQueryKeys } from "modules/BrandsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { BrandGroupFormPayload } from "modules/BrandsDashboard/components/BrandGroupModal/hooks";

export const useUpdateBrandGroupMutation = () =>
  useTypedMutation<BrandGroupFormPayload, void>({
    mutationFn: async payload => (await ApiInstance.post("/brands/groups/update", payload, ENV.carBaseURL)).data,
    onSuccess: payload => {
      const previousBrandGroups = typedQueryClient.getQueryData(BrandsDashboardQueryKeys.brandGroups);
      if (!previousBrandGroups) return;

      const groupIdx = previousBrandGroups.findIndex(group => group.id === payload.id);
      if (groupIdx === -1) return;

      typedQueryClient.setQueryData(BrandsDashboardQueryKeys.brandGroups, previousBrandGroups.with(groupIdx, { ...previousBrandGroups[groupIdx], ...payload }));
    }
  });
